import React from "react";
import { useHistory } from "react-router-dom";
import { ForgotPassword } from "../../templates/ForgotPassword";
import { Alert } from "../../atoms/Alert";

type Props = {
  onSubmit: (email: string) => void;
  isLoading: boolean;
  error: string;
  isSuccess: boolean;
};

const ForgotPasswordPage = ({ onSubmit, isLoading, isSuccess, error }: Props) => {
  const history = useHistory();

  const returnToLogin = () => {
    return history.push("/login");
  };

  return (
    <>
      <ForgotPassword
        onSubmit={onSubmit}
        returnToLogin={returnToLogin}
        isLoading={isLoading}
      />
      {(isSuccess) && (
          <Alert
            type="success"
            message="We have emailed your password reset link"
            showIcon
          />
      )}
      {(error) && <Alert type="error" message={error} showIcon />}
    </>
  );
};

export default ForgotPasswordPage;
